import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  InputComponent,
  TextareaComponent,
  TextareaSize,
} from '@ansys-internal/awc-angular/forms';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@ansys-internal/awc-angular/buttons';
import { ComponentWidth } from '@ansys-internal/awc-angular/core';
import {
  AWFNotificationProvider,
  DIALOG_DATA,
  DIALOG_REF,
  NavigateAction,
  NOTIFICATION_PROVIDER,
  SnackBarService,
  TableRefreshDataAction,
} from '@ansys-internal/awf-angular/shared';
import { IconComponent, Icons } from '@ansys-internal/awc-angular/icons';
import { ActionContributionsService } from '@ansys-internal/awf-angular/contributions';
import { State } from '@ansys-internal/awf-angular/store';
import { Project } from '@ansys/cloud-angular-client';
import {
  DashboardTables,
  ProjectCreatedAction,
  ProjectsService,
  Tabs,
} from '@ansys-internal/awf-angular/dashboard';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'dashboard-create-project-dialog',
    templateUrl: './create-project.component.html',
    styleUrls: ['./create-project.component.scss'],
    imports: [
        CommonModule,
        InputComponent,
        ButtonComponent,
        TextareaComponent,
        IconComponent,
    ]
})
export class CreateProjectComponent {
  public title: string = '';
  public description: string = '';
  public type: ButtonType = ButtonType.SECONDARY;
  public size: ButtonSize = ButtonSize.MEDIUM;
  public awcSizing: ComponentWidth = ComponentWidth.FILL;
  protected spinner: Icons = Icons.SPINNER;
  protected loading: boolean = false;
  protected showHint: boolean = false;

  constructor(
    @Inject(DIALOG_DATA)
    protected data: { callback: (project: Project) => void },
    @Inject(DIALOG_REF) private dialogRef: DialogRef,
    private snackbar: SnackBarService,
    private actions: ActionContributionsService,
    @Inject(NOTIFICATION_PROVIDER)
    private notifications: AWFNotificationProvider,
    private state: State,
    private projectService: ProjectsService
  ) {}

  protected confirm(): void {
    if (!this.title.length) {
      this.snackbar.error('Please enter a project title');
      this.showHint = true;
      return;
    }

    this.loading = true;
    this.projectService
      .createProject(this.title, this.description)
      .then(async (project: Project | unknown) => {
        if (!project) {
          return this.dialogRef.close();
        }

        await this.actions.execute(NavigateAction, [
          'ws',
          Tabs.DASHBOARD,
          'projects',
          (project as Project)?.projectId as string,
        ]);

        await this.actions.execute(ProjectCreatedAction, project);
        setTimeout(() => {
          this.actions.execute(TableRefreshDataAction, DashboardTables.PROJECT);
        });

        this.data.callback(project);
        this.dialogRef.close();
      });
  }
}
